
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Form, InputGroup, Modal, Table } from 'react-bootstrap';
import Select from 'react-select';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { itemListRes, itemListTodo } from '../../redux/Slices/Items/ItemList';
import debounce from "lodash/debounce"
import Swal from 'sweetalert2';
import Loader from '../../component/loader/Loader';
import { DistributorListRes, DistributorListTodo } from '../../redux/Slices/Orders/DistributorList';

export default function AddItem(props) {
    const { modal, divisionId, setModal, OrderDetails, orderItems, setOrderItems } = props;
    const dispatch = useDispatch();
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [pageIndex, setPageIndex] = useState(1);
    const [category, setCategory] = useState('');
    const [distributor, setDistributor] = useState('');
    const [custModal, setCustModal] = useState(false);
    const [items, setItems] = useState([]);
    // const [items1, setItems1] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const distributer = useSelector(state => state?.DistributorList?.data?.data);
    const itemListData = useSelector(state => state?.ItemsList?.data?.data)

    console.log(itemListData)

    const handleClose = () => {
        setModal(false);
        dispatch(itemListTodo());
        setCategory('');
        setItems([]);
        setDistributor('')
    };

    const handleClose2 = () => {
        setCustModal(false)
    };

    const customerModel = () => {
        setCustModal(true)
        setLoading3(true)
        dispatch(DistributorListTodo()).then(() => dist_res())
    }

    const dist_res = () => {
        if (DistributorListRes?.success) {
            setLoading3(false)
        } else {
            setLoading3(false)
        }
    }

    const customer_option = distributer && distributer.map(val => ({
        value: val.vplant_name,
        label: val.vplant_name,
        address: val.vcustomer_address,
        city: val.vcity_name,
        mobile: val.vcustomer_mobile_no
    }));

    const CustomOption = (props) => {
        const { innerRef, innerProps, isSelected, data } = props;
        return (
            <div className="ps-2 pe-2">
                <div
                    ref={innerRef}
                    {...innerProps}
                    className="mb-1 border border-secondary border-opacity-25"
                    style={{ padding: '0.5rem', borderRadius: '0.375rem', backgroundColor: isSelected ? '#cfe2ff' : '#e2e3e5' }}
                >
                    <div className='mb-1' style={{ fontSize: '14px' }}>
                        <span className='fw-semibold'>Plant Name : {data.label}</span><br />
                        <span className='fw-semibold'>Mobile Number : {data.mobile}</span><br />
                        <span className='fw-semibold'>Address : {data.address}</span><br />
                        <span className='fw-semibold'>City : {data.city}</span><br />
                    </div>
                    {/* <div className='d-flex justify-content-between mt-1' style={{ fontSize: '12px' }}>
                <div>
                  <span>{data?.department}</span><br />
                  <span className='fw-semibold'>{data?.address}</span><br />
                </div>
                <div>
                </div>
              </div> */}
                </div>
            </div>
        );
    }

    const Category = useSelector(state => state?.CategoryList?.data?.data);

    const category_option = Category && Category.map(val => ({
        value: val.citem_category_short_name,
        label: val.vitem_category_name
    }));


    const handleSearch = debounce((e) => {
        setItems([]);
        setInputValue(e || '');
        setPageIndex(1); // Reset page index for new search

        if (e) {
            setLoading2(true);
            dispatch(itemListTodo({ search: e, division_id: divisionId, pageIndex: 1, category }))
                .then((res) => itemListFun2(res?.payload?.data));
        }
    }, 500);

    useEffect(() => {
       dispatch(itemListTodo({ 'search': '', division_id: '', "pageIndex": pageIndex, "category": '' })).then((res)=> setItems(res?.payload.data))
    }, [modal])
    


    // const handleCategory = (data) => {
    //     setItems([]);
    //     setCategory(data);
    //     setInputValue(''); // Clear search on category change
    //     setPageIndex(1); // Reset page index for new category

    //     if (data) {
    //         setLoading2(true);
    //         dispatch(itemListTodo({ search: '', division_id: divisionId, pageIndex: 1, category: data }))
    //             .then((res) => itemListFun2(res?.payload?.data));
    //     }
    // };

    const itemListFun2 = (res) => {
        if (itemListRes?.success) {
            setLoading2(false);
            setItems(
                res && res.length > 0
                    ? res.map(item => ({
                        ...item,
                        sec_quantity: 0,
                        quantity: item.mweight
                    }))
                    : []
            );
            // setItems1(res)
        } else {
            setLoading2(false);
            setItems([]);
        }
    };

    const handleScroll = useCallback((container) => {
        if (container.scrollTop + container.clientHeight >= container.scrollHeight - 100) {
            // Load more if scrolled near the bottom
            setPageIndex((prev) => prev + 1);
        }
    }, []);

    useEffect(() => {
        if (pageIndex > 1) {
            setLoading2(true);
            dispatch(itemListTodo({ 'search': inputValue, division_id: divisionId, "pageIndex": pageIndex, "category": category }))
                .then(() => loadmoreRes());
        }
    }, [pageIndex]);

    // useEffect(() => {
    //     dispatch(itemListTodo({ 'search': '', division_id: '', "pageIndex": pageIndex, "category": '' }))
    // }, [pageIndex])
    

    const loadmoreRes = () => {
        if (itemListRes?.success) {
            const additionalItems = itemListRes.data.map(item => ({
                ...item,
                sec_quantity: 1,
                quantity: item.mweight
            }));
            setItems((prev) => [...prev, ...additionalItems]);
            setLoading2(false);
        } else {
            setLoading2(false);
        }
    };

    const handleSecQuantityChange = (vitem_code, secQuantityValue) => {
        setItems(prevItems =>
            prevItems.map(item => {
                if (item.vitem_code === vitem_code) {
                    return {
                        ...item,
                        sec_quantity: secQuantityValue,
                        quantity: secQuantityValue
                    };
                }
                return item;
            })
        );
    };

    const saveItemsFun = (data) => {
        const taxRate = data.mtax_rate;
        let cgst = 0, sgst = 0, igst = 0;

        if (localStorage.getItem('allowVatSales') === "Y") {
            if (localStorage.getItem("istate_id") === localStorage.getItem("icompany_state_id")) {
                cgst = taxRate / 2;
                sgst = taxRate / 2;
            } else {
                igst = taxRate;
            }
        }

        const taxValue = data.quantity * data.mrate;
        const sgstTotl = sgst * taxValue / 100;
        const cgstTotl = cgst * taxValue / 100;
        const igstTotl = igst * taxValue / 100;

        const SaveItemData = {
            iitem_detail_id: '0',
            iitem_master_id: data.item_master_id,
            vpurchase_order_code: OrderDetails?.vpurchase_order_code || "",
            model_no: data.vitem_code,
            vcustomer_item_name: data.vitem_name,
            vitem_code: data.vitem_code,
            vmarketing_item_code: data?.vitem_code,
            description: data.vitem_description,
            unit: data.iunit,
            irate_per_unit: OrderDetails?.irate_per_unit || 1,
            irate_per_unit_or: OrderDetails?.irate_per_unit_or || 1,
            fquantity: data.quantity, // Uses the updated quantity
            // new_fquantity: data.sec_quantity, // Updated quantity
            vtemp_customer: distributor ? distributor : '',
            mrate: data.mrate,
            mdiscount_per: data?.mdiscount_per,
            mdiscount_value: OrderDetails?.mdiscount_value || 0,
            msgst_tax_per: sgst,
            mcgst_tax_per: cgst,
            migst_tax_per: igst,
            msgst_tax_value: sgstTotl,
            mcgst_tax_value: cgstTotl,
            migst_tax_value: igstTotl,
            vitem_remark: 'remark',
            ipriority: OrderDetails?.ipriority || 0,
            isec_unit_id: data.isec_unit_id,
            mweight: data?.mweight,
            ischeme_id: '',
            vprice_list_no: '',
            vhsn_code: data?.vhsn_code,
            iware_house_id: data.iware_house_id,
            bsnomain: OrderDetails?.bsnomain ? OrderDetails?.bsnomain : 0,
            ibusiness_area_id: data.ibusiness_area_id || localStorage.getItem('ibusiness_area_id')
        };

        if (!orderItems.some(item => item.model_no === SaveItemData.model_no)) {
            setOrderItems(prev => [...prev, SaveItemData]);
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Item Added Successfully!",
                showConfirmButton: false,
                timer: 800
            });
        } else {
            Swal.fire({
                title: "Items",
                text: "Item Already Exists!",
                icon: "warning"
            });
        }
    };



    return (
        <>
            <Modal show={modal} onHide={handleClose} backdrop="static" keyboard={false} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Select Item</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        {/* <div className='col-md-4 mt-1'>
                            <Select
                                placeholder='Select Category'
                                options={category_option || []}
                                isClearable
                                onChange={(e) => handleCategory(e?.value)}
                            />
                        </div> */}
                        <div className='col-md-5 mt-1' >
                            <Form.Control
                                type="text"
                                placeholder='Search Item'
                                onChange={(e) => handleSearch(e.target.value)}
                            />
                        </div>
                        {localStorage.getItem('icustomer_type_id') == '1' ? "" : <div className='col-md-3 mt-1'>
                            <Button type='button' variant="" onClick={customerModel} className='ms-2 save_btn'>Customer Details</Button><br />
                        </div>}
                        {/* <Button onClick={() => setPageIndex(prev => prev + 1)} className='ms-3'>Load More</Button> */}
                    </div>
                    <div className='mt-3'>
                        {loading2 ? (
                            <div className='d-flex justify-content-center mt-5 pb-5'>
                                <Loader />
                            </div>
                        ) : (
                            <PerfectScrollbar style={{ height: '70vh' }}
                                onScrollY={(container) => items?.length < 500 ? '' : handleScroll(container)}
                            >
                                <Table striped bordered hover className='item_table'>
                                    <thead className='head_table2'>
                                        <tr>
                                            <th>S No.</th>
                                            <th>ITEM</th>
                                            <th>UNIT</th>
                                            <th>HSN NO.</th>
                                            <th>STOCK</th>
                                            <th>CATEGORY</th>
                                            <th>MANUFACTURE</th>
                                            <th>ORDER QUANTITY</th>
                                            <th>ACTION</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            items?.length ?
                                                items?.map((item, index) => {
                                                    const isItemInOrderReference = orderItems.some(ref => ref.model_no === item.vitem_code);
                                                    return (
                                                        <tr key={item.vitem_code}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.vitem_name}</td>
                                                            <td> {item?.vunit_short_name}</td>
                                                            <td> {item?.vhsn_code}</td>
                                                            <td>{item?.mstock}</td>
                                                            <td>{item.vcategory_name}</td>
                                                            <td>{item.vparent_group_name}</td>
                                                            <td>
                                                                <InputGroup className="">
                                                                    <Form.Control
                                                                        type="text"
                                                                        className='form_input'
                                                                        name="sec_quantity"
                                                                        value={item.sec_quantity || ''} // Handle empty value on initial load
                                                                        onChange={(e) => handleSecQuantityChange(item.vitem_code, parseInt(e.target.value, 10))}
                                                                    />
                                                                    {/* <InputGroup.Text id="basic-addon2">{item?.vsecondary_unit}</InputGroup.Text> */}
                                                                </InputGroup>
                                                                {/* {!item.sec_quantity ? (
                                                                <span style={{ fontSize: '12px', color: 'red' }}>Quantity is Required</span>
                                                            ) : isNaN(item.sec_quantity) ? (
                                                                <span style={{ fontSize: '12px', color: 'red' }}>Quantity must be an integer</span>
                                                            ) : null} */}
                                                                {/* {item.sec_quantity ? '' :   <span style={{ fontSize: '12px', color: 'red' }}>Quantity is Required</span>} */}
                                                            </td>
                                                            <td>
                                                                <Button
                                                                    onClick={() => saveItemsFun(item)}
                                                                    className='ms-3'
                                                                    disabled={isItemInOrderReference || !item.sec_quantity} // Disable if item ID is in orderReference
                                                                >
                                                                    {isItemInOrderReference ? 'ADDED' : 'ADD'}
                                                                </Button>
                                                                {/* <Button onClick={() => saveItemsFun(item)} className='ms-3'>ADD</Button> */}
                                                            </td>
                                                        </tr>
                                                    )
                                                }


                                                ) :
                                                <tr>
                                                    <td colSpan={9}>   <div className='d-flex justify-content-center mt-5 mb-5'>
                                                        <h3 style={{ color: "grey" }}>ITEM NOT FOUND</h3>
                                                    </div></td>
                                                </tr>
                                        }
                                    </tbody>
                                </Table>
                            </PerfectScrollbar>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
            <div>
                <Modal show={custModal} onHide={handleClose2} backdrop="static" keyboard={false} size="md" style={{ backgroundColor: "rgb(91 88 88 / 79%)" }}>

                    <div >
                        <Modal.Header closeButton>
                            <Modal.Title> Customer Details</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className='pt-5 pb-5'>
                            {loading3 ?
                                <div className='d-flex justify-content-center mt-5 pb-5'>
                                    <Loader />
                                </div> :

                                <div>
                                    <Select
                                        placeholder='Select Customer'
                                        options={customer_option || []}
                                        isLoading={loading3}
                                        components={{ Option: CustomOption }}
                                        isClearable
                                        onChange={(e) => setDistributor(e?.value)}
                                    />
                                </div>}
                        </Modal.Body>
                    </div>
                </Modal>
            </div>
        </>

    );

}



// const handleCategory = (data) => {

//     setCategory(data);
//     if (data) {
//         setLoading2(true);
//         dispatch(itemListTodo({ 'search': '', "pageIndex": pageIndex, "category":data }))
//             .then(() => itemListFun2());
//     } else {
//         setItems([]);
//         setLoading2(false);
//     }
// };